<template>
    <div class="form-group form-group-with-search datatable-search">
        <span :key="'search'" class="form-control-feedback">
            <app-icon name="search" />
        </span>
        <input type="text" class="form-control" v-model="searchValue" :placeholder="$t('search')"
            @keydown.enter.prevent="getSearchValue" />
        <button
            type="button"
            class="btn btn-search-action"
            :aria-label="$t('search')"
            @click.prevent="getSearchValue(searchValue)"
        >
            <app-icon name="search" />
        </button>
    </div>
</template>

<script>
    export default {
        name: "AppSearch",
        data() {
            return {
                searchValue: '',
            }
        },
        watch: {
            searchValue: function (value) {
                if (value === '')
                    this.getSearchValue();
            }
        },
        methods: {
            getSearchValue() {
                this.$emit('input', this.searchValue);
            },
        }
    }
</script>
